<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="dialogTitle" center :width="contentWidth+'px'"
    :close-on-click-modal="closeable" @close="whenDialogClose">
    <div class="my-dialog-con df-l-c-fs w100p">
      <!-- :style="'min-height: '+contentHeight+'px;'" -->
      <div class="my-dialog-ctr w100p">
        <slot name="content"></slot>
      </div>
      <div class="my-dialog-btm w100p df-c-sa" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    dialogTitle: {
      type: String,
      default: '',
    },
    contentWidth: {
      type: [Number, String],
      default: 700,
    },
    // contentHeight: {
    //   type: [Number, String],
    //   default: 440,
    // },
    closeable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowDialog: false,
    }
  },
  methods: {
    open() {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
/deep/.el-dialog{margin-top: 10vh!important;}
.dialog-square{
  // /deep/.el-dialog{height: 500px;position: absolute;top: 0;left: 0;bottom: 0;right: 0;margin: auto!important;}
  /deep/.el-dialog__header{height: 60px;line-height: 60px;padding: 0;background: #374978;}
  /deep/.el-dialog__title,
  /deep/.el-dialog__headerbtn .el-icon-close::before{color: #fff;font-size: 20px;}
  // /deep/.el-dialog__headerbtn{top: 0;}
  /deep/.el-dialog__body{padding: 0;word-break: normal;}

  // .my-dialog-con{height: 440px;}
  // .my-dialog-ctr{flex: 1;}
  .my-dialog-btm{height: 110px;}
}
</style>